module.exports = __webpack_public_path__ + "img/666.a77362d2.png";